export default ['NY', 'MIAMI', 'LA', 'CHIGO', 'TOR', 'BER', 'LUD', 'LBH', 'BCL']
